import React, { useCallback, useState } from 'react';

import './input.scss';
import classNames from 'classnames';
import { CrossedEyeIcon, EyeIcon } from 'src/assets';

export const Input = (props) => {
  const { label, value, placeholder, onChange, type = 'text', errorMessage = '' } = props;

  const [isVisiblePassword, setIsVisiblePassword] = useState(false);

  const inputStyles = classNames('input', {
    'input-error': errorMessage,
  });

  const onEyeClick = useCallback(() => {
    setIsVisiblePassword((prev) => !prev);
  }, []);

  return (
    <div className="input-wrapper">
      <label className="input-label" htmlFor={label}>
        {label}
      </label>
      <div style={{ position: 'relative' }}>
        <input
          className={inputStyles}
          id={label}
          value={value}
          placeholder={placeholder}
          onChange={onChange}
          type={isVisiblePassword ? 'text' : type}
        />
        {type === 'password' && (
          <div className="input-eye-wrapper" onClick={onEyeClick}>
            {isVisiblePassword ? (
              <img src={EyeIcon} alt={EyeIcon} />
            ) : (
              <img src={CrossedEyeIcon} alt={CrossedEyeIcon} />
            )}
          </div>
        )}
      </div>
      {errorMessage && <div className="input-error-message">* {errorMessage}</div>}
    </div>
  );
};
